import React, { useState } from "react";
import Icon from "../../../common/components/Icon/Icon";
import cx from "classnames";
import styles from "./EditClientButton.module.scss";
import FamilySettingModal from "../Modals/FamilySettingsModal/FamilySettingsModal";
import { useHistory } from "react-router-dom";
import ProductType from "../../../common/interfaces/enums/ProductType";

interface IEditClientButtonProps {
    className?: string;
    currentProduct?: ProductType;
    isFromDAP?: boolean;
    showWarning?: () => void;
    setWarningNextStepUrl?: (url: string) => void;
}

const EditClientButton: React.FC<IEditClientButtonProps> = (props) => {
    const { className, currentProduct } = props;

    const [isOpen, setIsOpen] = useState(false);
    const history = useHistory();

    const buttonClassNames = cx(
        "panel-card",
        "padding-2xl",
        "text-font-size-m",
        "text-brand",
        "layout-flex-row--centered",
        styles["button"],
        {
            [className]: !!className
        }
    );

    const content = (
        <React.Fragment>
            <Icon id="PersonIcon" size="2xl" className="space-m "></Icon>
            Edit who needs cover
        </React.Fragment>
    );

    return (
        <React.Fragment>
            <FamilySettingModal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                onSubmit={() => history.push("/products")}
            />

            <button
                className={cx(buttonClassNames, "layout-hidden-mobile")}
                onClick={(e) => {
                    e.preventDefault();
                    setIsOpen(true);
                }}>
                {content}
            </button>
            <button
                className={cx(buttonClassNames, "layout-hidden-desktop")}
                onClick={(e) => {
                    e.preventDefault();

                    const params = new URLSearchParams();
                    if (currentProduct) {
                        params.append("product", currentProduct);
                    }

                    const isQuoteWarningConfirm =
                        !!window.localStorage.getItem("quote-modified-warning") || false;
                    if (props.isFromDAP && !isQuoteWarningConfirm) {
                        props.setWarningNextStepUrl("/family?" + params.toString());
                        props.showWarning();
                        return;
                    }
                    history.push("/family?" + params.toString());
                }}>
                {content}
            </button>
        </React.Fragment>
    );
};

export default EditClientButton;
